/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this.$el = $('#header');
    this.$menuToggle = this.$el.find('.header__menu-toggle');

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(window.PXUTheme.stickyPin.getAnnouncementOffset());
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click',  '[data-show-search-trigger]', function(){
      window.PXUTheme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function(e) {
        var $this = $(this);
        window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        window.PXUTheme.jsHeader.showSearch();
      }
    });

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    const stickyPin = window.PXUTheme.stickyPin;
    const $stickyEl = $('#header');

    $(window).off('.headerPinSticky');
    $stickyEl.off('.headerPinSticky sticky-start sticky-end sticky-update');

    $stickyEl.closest('.is-relative').find('.search-overlay')
      .removeClass('sticky-search')
      .css('top', '100%');

    stickyPin.unwrap($stickyEl, 'header-sticky-wrapper');
    $stickyEl.removeClass('sticky--enabled');

    // Restore centered-layout mini cart when leaving sticky/pinned state
    if (window.PXUTheme.theme_settings.header_layout == 'centered') {
      $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
    }

    if (this.$el) {
      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
    }
    if (this.$menuToggle) {
      this.$menuToggle.removeClass('is-active');
    }

    stickyPin.syncSpacers();
  },
  enableSticky: function(offset) {
    const topOffset = typeof offset === 'number' ? offset : window.PXUTheme.stickyPin.getAnnouncementOffset();

    this.disableSticky();

    // Overlay headers keep scroll-threshold sticky so they can sit over the hero at page top
    if (this.enable_overlay === true) {
      this._enableLegacySticky(topOffset);
      return;
    }

    this._enablePinnedSticky();
  },
  _updateSearchOverlayOffset: function($stickyEl) {
    let headerHeight = 0;
    let announcementHeight = 0;

    if (
      window.PXUTheme.jsHeader.enable_sticky == true
      && window.PXUTheme.theme_settings.header_layout != 'vertical'
    ) {
      headerHeight = $stickyEl.outerHeight() || window.PXUTheme.jsHeader.getHeaderHeight();
    }

    if (window.PXUTheme.theme_settings.header_layout != 'vertical') {
      announcementHeight = window.PXUTheme.stickyPin.getAnnouncementOffset();
    }

    $stickyEl.closest('.is-relative').find('.search-overlay')
      .addClass('sticky-search')
      .css('top', (headerHeight + announcementHeight) + 'px');
  },
  _enablePinnedSticky: function() {
    const stickyPin = window.PXUTheme.stickyPin;
    const $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    const $wrapper = stickyPin.wrap($stickyEl, 'header-sticky-wrapper');
    $wrapper.addClass('is-sticky');

    const pin = () => {
      const height = $stickyEl.outerHeight() || 0;
      const topOffset = stickyPin.getAnnouncementOffset();

      stickyPin.lockSpacer($wrapper, height);
      stickyPin.applyFixed($stickyEl, topOffset, 70);
      stickyPin.syncSpacers();
      this._updateSearchOverlayOffset($stickyEl);
    };

    pin();

    if (window.PXUTheme.theme_settings.header_layout == 'centered') {
      $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
    }

    $(window).on('resize.headerPinSticky', pin);
  },
  _enableLegacySticky: function(topOffset) {
    const $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');
    $stickyEl.off('sticky-start sticky-end sticky-update');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: topOffset || 0
    })
    .on('sticky-start', () => {
      if (window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      this._updateSearchOverlayOffset($stickyEl);

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();
      } else if (this.enable_overlay === true) {
        this.disableOverlayStyle();
      }
    })
    .on('sticky-end', () => {
      $stickyEl.closest('.is-relative').find('.search-overlay')
        .removeClass('sticky-search')
        .css('top', '100%');

      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      if (window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    });
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');

    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
        },
        afterShow: function() {
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
      })
    }
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $(window).off('.headerStickyInit .headerPinSticky');
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    if (this.$menuToggle) this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
}

/******/ })()
;